export const stockLocationFabActions = (stockId, locationId) => {
    return [
        {
            icon: '$locationLock',
            label: 'stocks.locations.locks.create.titleSimple',
            to: '/stocks/' + stockId + '/locations/' + locationId + '/locks/create'
        }
    ];
};
